import React from "react";
import { useLocation } from "react-router-dom";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";

import HeaderImage from "assets/img/agentwire-heading.png";
import PhoneImages from "assets/img/phone-images.png";
import UseCasesImage from "assets/img/use-cases.png";

export default function Home() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 flex  align-items-top"
        style={{
          backgroundColor: "#ecf3f9",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            height: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          <img src={HeaderImage} alt="AgentWire" />
        </div>
        <img src={PhoneImages} alt="AgentWire" />
        <img
          src={UseCasesImage}
          alt="AgentWire"
          style={{ marginTop: "20px" }}
        />
      </div>
    </>
  );
}
